import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LoginStyles from "../../styles/loginPageStyles.module.css";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { sendRequestPasswordEmail } from "../../network/apis/email.api";

const RequestForgotPassword = (props) => {
  const [formData, setFormData] = useState({ User_email: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(formData.User_email);
  };

  const handleEmailChange = (e) => {
    setFormData({ ...formData, User_email: e.target.value });
    setErrorMessage("");
    setSuccessMessage("");
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const emailDetails = {
        email: formData.User_email,
      };

      try {
        const response = await sendRequestPasswordEmail(emailDetails);
        setSuccessMessage("A reset link has been sent to your email.");
      } catch (error) {
        if (error.response) {
          setErrorMessage(
            `Error: ${
              error.response.data.error ||
              "An error occurred. Please try again."
            }`
          );
        } else if (error.request) {
          setErrorMessage(
            "Error: No response from the server. Please check your internet connection."
          );
        } else {
          setErrorMessage(`Error: ${error.message}`);
        }
      }
    } else {
      setErrorMessage("Please enter a valid email address.");
    }
  };

  return (
    <>
      <Container
        component="main"
        maxWidth="xs"
        className={LoginStyles.login_form_container}
      >
        <Box
          sx={{
            marginTop: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Forgot Password
          </Typography>
          <Typography
            component="p"
            variant="body2"
            sx={{ mt: 1, mb: 2, textAlign: "center" }}
          >
            Enter your email address and we'll send you a link to reset your
            password.
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={sendEmail}
            sx={{ mt: 0.5 }}
          >
            {errorMessage && (
              <Alert severity="error" fullWidth>
                {errorMessage}
              </Alert>
            )}
            {successMessage && (
              <Alert severity="success" fullWidth>
                {successMessage}
              </Alert>
            )}

            <Grid container spacing={2} mt={0.5}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  size="small"
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  value={formData.User_email}
                  onChange={handleEmailChange}
                />
              </Grid>
            </Grid>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                px: 10,
                backgroundColor: "#0c0092",
                fontWeight: "bold",
              }}
            >
              Send Reset Link
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default RequestForgotPassword;
